import { render } from "./cruisedAdmin.vue?vue&type=template&id=85b7b7bc&scoped=true"
import script from "./cruisedAdmin.vue?vue&type=script&lang=js"
export * from "./cruisedAdmin.vue?vue&type=script&lang=js"

import "./cruisedAdmin.vue?vue&type=style&index=0&id=85b7b7bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-85b7b7bc"

export default script